(function () {
  if (window.VaultPreloader) { window.vaultInit.drain('Preloader'); return; }
      /* The photos the shopper sees first: up to 6 on the first screen, plus the first row of a product grid
         that starts just under it (Shop All on phones), so those are loaded when the page appears. */
      window.vaultFirstSeenImages = function firstSeenImages(eagerOnly) {
        var vh = window.innerHeight;
        var all = Array.prototype.slice.call(document.querySelectorAll('#MainContent img')).filter(function (im) {
          return !eagerOnly || (im.loading !== 'lazy' && !im.hasAttribute('data-src'));
        });
        var box = function (im) { return im.getBoundingClientRect(); };
        var seen = all.filter(function (im) {
          var r = box(im);
          return r.width > 40 && r.top < vh && r.bottom > 0;
        }).slice(0, 6);
        var firstRow = all.filter(function (im) {
          if (im.getAttribute('fetchpriority') !== 'high' || seen.indexOf(im) !== -1) return false;
          var r = box(im);
          return r.width > 40 && r.top < vh * 1.3 && r.bottom > 0;
        }).slice(0, 4);
        return seen.concat(firstRow);
      };


  /* Both arrival and soft/history navigation await the same card preparation. */
  function prepareDefaultReturn() {
    function prepare() {
      return Promise.resolve(typeof window.vaultPrepareDefaultReturn === 'function' ? window.vaultPrepareDefaultReturn() : null).catch(function () { return null; });
    }
    if (document.readyState === 'loading') return new Promise(function (resolve) {
      document.addEventListener('DOMContentLoaded', function () { prepare().then(resolve); }, { once: true });
    });
    return prepare();
  }

  var phases = {
    arrival: function (root) {
      var ANIM_DURATION = 1030, HOLD_AFTER_LOAD = 400, EMERGENCY_TIMEOUT = 5000;
      var el = document.getElementById('preloader'), bootstrap = el && el.__vaultArrival;
      if (!bootstrap || bootstrap.expired) return;
      el.__vaultArrivalReady = true;
      var started = false, hidden = false, firstSeenImages = window.vaultFirstSeenImages;
      var text = bootstrap.text, logo = bootstrap.logo, logoInfo = bootstrap.logoInfo, logoReady = bootstrap.logoReady;
      var handoff = bootstrap.handoff, arrivalEntry = bootstrap.arrivalEntry, toTopLayer = bootstrap.toTopLayer;
      function hideOverlay() {
        if (hidden) {
          return;
        }

        hidden = true;
        if (window.__vaultLog) window.__vaultLog('[preloader] fade out');
        el.classList.add('preloader--hide');
        /* Only the arrival overlay is ours to clear while another transition owns the page. */
        if (!root.classList.contains('vault-leaving') && !photoOwnsEntry()) root.classList.remove('vault-cover');

        window.setTimeout(function () {
          if (!root.classList.contains('vault-leaving') && !photoOwnsEntry()) root.classList.remove('has-preloader');
          try { if (el.matches(':popover-open')) el.hidePopover(); } catch (err) {}
        }, 380);
      }

      function photoOwnsEntry() { return window.vaultPhotoOwnsEntry(); }
      /* History navigation must restore the page, without a frozen logo. */
      function clearPreloaderForHistory(entryFirst) {
        var run = arrivalRun;
        function clear() {
          if (run !== arrivalRun && !document.hidden) return;
          /* a reloaded Back: the page's entry covers first, so the page never shows before it (Mark 2026-10-20, video 1) */
          if (entryFirst && typeof window.vaultHistoryEntryNow === 'function') window.vaultHistoryEntryNow();
          started = true;
          hidden = true;
          var transition = el.style.transition;
          el.style.transition = 'none';
          el.classList.add('preloader--hide');
          if (!photoOwnsEntry() && !root.classList.contains('vault-leaving')) {
            root.classList.remove('has-preloader'); root.classList.remove('vault-cover');
          }
          try { if (el.matches(':popover-open')) el.hidePopover(); } catch (err) {}
          void el.offsetWidth;
          el.style.transition = transition;
        }
        if (typeof prepareDefaultReturn !== 'function') { clear(); return Promise.resolve(); }
        return prepareDefaultReturn().then(clear);
      }

      /* Only when Back/Forward brings the page back from memory — clearing on
         "pagehide" uncovered the old page while the next one was loading. */
      window.addEventListener('pageshow', function (e) {
        if (e.persisted) { arrivalRun++; clearPreloaderForHistory(); }
      });

      /* Back/forward can also reload a page when it was not kept in memory. */
      var historyEntry = window.performance && performance.getEntriesByType
        ? performance.getEntriesByType('navigation')[0] : null;
      if (historyEntry && historyEntry.type === 'back_forward') {
        if (!logoInfo || window.vaultFlyBackHere() || photoOwnsEntry()) clearPreloaderForHistory(true);
      }

      window.showVaultPreloader = function () {
        hidden = false;
        started = true;

        root.classList.add('has-preloader');
        toTopLayer(el);
        el.classList.remove('preloader--hide', 'preloader--run');

        if (text) {
          text.style.visibility = 'visible';
          text.style.animation = 'none';
          void text.offsetWidth;
          text.style.animation = '';
        }

        void el.offsetWidth;
        el.classList.add('preloader--run');

        window.setTimeout(function () {
          if (!document.hidden) {
            hideOverlay();
          }
        }, EMERGENCY_TIMEOUT);
      };

      var arrivalRun = 0;
      window.addEventListener('popstate', function () { arrivalRun++; clearPreloaderForHistory(); });
      window.addEventListener('pagehide', function () { arrivalRun++; });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { arrivalRun++; clearPreloaderForHistory(); }
      });
      function startAnimation() {
        if (started) {
          return;
        }

        started = true;

        var run = arrivalRun;
        logoReady.then(function () {
          if (run !== arrivalRun || hidden) return;
          nextFrame(function () {
            if (run !== arrivalRun || hidden) return;
            {
              el.classList.add('preloader--run');

              /* Hide when the zoom/fade has truly finished (a busy phone can
                 delay it), with a timer as a safety net. */
              var mover = el.classList.contains('preloader--logo') ? logo : text;
              var safety = window.setTimeout(function () { if (run === arrivalRun) hideOverlay(); }, ANIM_DURATION + 400);

              if (mover) {
                mover.addEventListener('animationend', function () {
                  window.clearTimeout(safety);
                  if (run === arrivalRun) hideOverlay();
                }, { once: true });
              }
            }
          });
        });
      }

      /* Next painted frame, or 120ms if the tab is in the background. */
      function nextFrame(fn) {
        var done = false;
        function run() {
          if (done) return;
          done = true;
          fn();
        }
        requestAnimationFrame(function () { requestAnimationFrame(run); });
        window.setTimeout(run, 120);
      }

      function beginAfterFullHold() {
        window.setTimeout(
          startAnimation,
          HOLD_AFTER_LOAD
        );
      }

      /* Start the ending once the page is BUILT and the images the shopper
         will see first have loaded — not on the browser's "load" event, which
         also waits for tracking/analytics calls (seconds later, unseen). */
      function topImagesReady() {
        var imgs = firstSeenImages(false);
        return Promise.all(imgs.map(function (im) {
          if (im.complete) return 0;
          return new Promise(function (ok) {
            im.addEventListener('load', ok, { once: true });
            im.addEventListener('error', ok, { once: true });
          });
        }));
      }

      var readyStarted = false;
      function onPageReady() {
        if (readyStarted) return;
        readyStarted = true;
        if (el.classList.contains('preloader--logo') && !location.hash && !(historyEntry && historyEntry.type === 'back_forward')) {
          requestAnimationFrame(function () { if (arrivalEntry === window.vaultEntryKey() && !hidden) window.scrollTo(0, 0); });
        }
        Promise.all([Promise.race([
          topImagesReady(),
          new Promise(function (ok) { window.setTimeout(ok, 2500); })
        ]), prepareDefaultReturn(), window.vaultLookArrivalReady]).then(beginAfterFullHold);
      }

      if (document.readyState !== 'loading') {
        onPageReady();
      } else {
        document.addEventListener('DOMContentLoaded', onPageReady, { once: true });
      }
      window.addEventListener('load', onPageReady, { once: true });

      window.setTimeout(function () {
        if (!started) {
          Promise.all([prepareDefaultReturn(), window.vaultLookArrivalReady]).then(startAnimation);
        }
      }, EMERGENCY_TIMEOUT);

    },
    navigation: function () {

    (function () {
      if (window.Shopify && window.Shopify.designMode) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var LEAVE_MS = 350;   /* blur/fade before the next page starts loading */
      var FAST_MS = 120;    /* pull-to-refresh: cover before the browser moves the page */
      var root = document.documentElement;
      var logos = window.VAULT_LOGOS || {};
      var leaving = false;
      var leaveTimer = 0;
      var showTimer = 0;
      var coverTimer = 0;
      var undoTimer = 0;
      var stuckTimer = 0;
      var slowTimer = 0;
      var leaveCycle = 0, historyArrival = null;

      /* The photo owns the transition only while it exists; later links keep their preloader. */
      function photoTransitionActive() { return window.vaultPhotoOwnsEntry(); }

      function dbg(msg) {
        if (window.__vaultLog) window.__vaultLog('[leave] ' + msg);
      }

      /* Build the white layer up front so the fade always starts on the first tap. */
      var veil = document.createElement('div');
      veil.className = 'vault-leave';
      veil.setAttribute('aria-hidden', 'true');
      veil.innerHTML = '<div class="vault-preloader-stage"><div class="vault-leave__text">FASHION KNOWS NO BOUNDS</div><img class="vault-leave__logo" alt="" decoding="async"></div>';
      document.body.appendChild(veil);
      var veilLogo = veil.querySelector('.vault-leave__logo');

      function logoFor(url) {
        var info = logos[url.pathname.replace(/\/+$/, '')];
        return info ? info[0] : null;
      }

      /* A page change on this site (not a #section jump on the same page). */
      function isLeave(url) {
        if (url.origin !== location.origin) return false;
        if (url.pathname === location.pathname && url.search === location.search && url.hash) return false;
        /* Cart, checkout and account go straight through — no white layer,
           no delay — exactly as before (protects the cart → checkout step). */
        if (/^\/(cart|checkout|checkouts|account)(\/|$)/.test(url.pathname)) return false;
        return true;
      }

      function linkFrom(e) {
        if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return null;
        var a = e.target.closest && e.target.closest('a[href]');
        if (!a || (a.target && a.target !== '_self') || a.hasAttribute('download')) return null;
        var url = new URL(a.href, location.href);
        return isLeave(url) ? url : null;
      }

      function showVeil(url, fast, onCovered) {
        leaving = true;
        root.classList.add('vault-leaving');
        var cycle = ++leaveCycle;
        window.clearTimeout(undoTimer);
        var src = url && logoFor(url);
        var held = veil.classList.contains('vault-leave--hold'); /* the leaving page's logo waits in the middle */
        if (!held) veil.classList.remove('vault-leave--logo-ready');
        veil.classList.toggle('vault-leave--fast', !!fast);
        if (held) {
          /* keep it */
        } else if (src) {
          if (veilLogo.getAttribute('src') !== src) veilLogo.src = src;
          veil.classList.add('vault-leave--logo');
          /* Never show an old or partially decoded logo during the fade. */
          var ready = veilLogo.decode ? veilLogo.decode() : new Promise(function (resolve, reject) {
            if (veilLogo.complete) {
              if (veilLogo.naturalWidth) resolve(); else reject();
              return;
            }
            veilLogo.addEventListener('load', resolve, { once: true });
            veilLogo.addEventListener('error', reject, { once: true });
          });
          ready.then(function () {
            if (leaving && cycle === leaveCycle && veilLogo.getAttribute('src') === src) {
              veil.classList.add('vault-leave--logo-ready');
            }
          }).catch(function () {});
        } else {
          veil.classList.remove('vault-leave--logo');
        }

        /* Move into the top layer (above every section/app), then fade. */
        if (!veil.matches(':popover-open')) document.body.appendChild(veil);
        if (typeof veil.showPopover === 'function') {
          try {
            veil.popover = 'manual';
            if (!veil.matches(':popover-open')) veil.showPopover();
          } catch (err) {}
        }

        /* Lock in the see-through starting point so the fade always plays. */
        void getComputedStyle(veil).opacity;

        /* Slow connection: after 2.5s of waiting, show the words/logo. */
        veil.classList.remove('vault-leave--slow');
        window.clearTimeout(slowTimer);
        slowTimer = window.setTimeout(function () {
          if (leaving && cycle === leaveCycle) veil.classList.add('vault-leave--slow');
        }, (fast ? FAST_MS : LEAVE_MS) + 2500);

        var shown = false;
        function show() {
          if (shown || !leaving || cycle !== leaveCycle) return;
          shown = true;
          veil.classList.add('vault-leave--on');
          dbg('fade in ' + (fast ? 'fast' : 'normal') + ' to ' + (url ? url.pathname : 'reload'));

          /* Once the white is solid, hide the page under it too. While the
             next page loads, Chrome on iPhone can move the old page and
             uncover a strip at the bottom — this way that strip is white. */
          window.clearTimeout(coverTimer);
          coverTimer = window.setTimeout(function () {
            if (!leaving || cycle !== leaveCycle) return;
            root.classList.add('vault-cover');
            dbg('page covered');
            if (window.__vaultSample) window.__vaultSample('[leave] covered');
            if (onCovered) onCovered();
          }, (fast ? FAST_MS : LEAVE_MS) + 10);
        }
        if (fast) {
          show();
          return;
        }
        requestAnimationFrame(function () { requestAnimationFrame(show); });
        showTimer = window.setTimeout(show, 60);
      }

      /* Leaving a brand/idol page: its logo comes in big, shrinks and
         dissolves (one motion) on the white, then the normal change continues. */
      var DEPART_MS = 1300;
      /* Load this page's logo early, so its exit never plays on an empty image. */
      var pageLogo = logos[location.pathname.replace(/\/+$/, '')];
      if (pageLogo) {
        var pre = new Image();
        pre.decoding = 'async';
        pre.src = pageLogo[0];
      }
      function departFrom(path, next) { departThen(next, false, path, true); }
      /* hold: the next page still has to load here (soft swap) – the logo stops in the middle and waits (softReveal
         blurs it away once that page is ready) */
      function departThen(next, skip, path, hold, cancelled) {
        var cycle = leaveCycle, entry = window.vaultEntryKey();
        var cancelledOnce = false;
        function current() { return cycle === leaveCycle && entry === window.vaultEntryKey() && !document.hidden; }
        function cancel() {
          if (cancelledOnce) return;
          cancelledOnce = true; departThen.waited = false;
          if (cancelled) cancelled();
        }
        var info = logos[(path || location.pathname).replace(/\/+$/, '')];
        if (skip || !info) { next(false); return; }
        if (veilLogo.getAttribute('src') !== info[0]) veilLogo.src = info[0];
        if (!departThen.waited && !(veilLogo.complete && veilLogo.naturalWidth)) {
          departThen.waited = true;
          var resume = function () { if (current()) departThen(next, skip, path, hold, cancelled); else cancel(); };
          Promise.race([
            veilLogo.decode ? veilLogo.decode().catch(function () {}) : Promise.resolve(),
            new Promise(function (ok) { window.setTimeout(ok, 400); })
          ]).then(resume);
          return;
        }
        departThen.waited = false;
        leaving = true;
        root.classList.add('vault-leaving');
        if (!veil.matches(':popover-open')) document.body.appendChild(veil);
        if (typeof veil.showPopover === 'function') {
          try { veil.popover = 'manual'; if (!veil.matches(':popover-open')) veil.showPopover(); } catch (err) {}
        }
        if (veilLogo.getAttribute('src') !== info[0]) veilLogo.src = info[0];
        veilLogo.style.setProperty('--logo-zoom', info[1]);
        veil.classList.remove('vault-leave--exit', 'vault-leave--return', 'vault-leave--logo-ready', 'vault-leave--hold', 'vault-leave--holdout');
        veil.classList.add('vault-leave--logo', hold ? 'vault-leave--hold' : 'vault-leave--depart');
        void getComputedStyle(veil).opacity;
        requestAnimationFrame(function () { if (current()) veil.classList.add('vault-leave--on'); });
        window.setTimeout(function () { if (current()) veil.classList.add('vault-leave--on'); }, 120);
        window.setTimeout(function () { if (current()) root.classList.add('vault-cover'); }, LEAVE_MS + 10);
        var done = false;
        function go() {
          if (done) return;
          done = true;
          veilLogo.removeEventListener('animationend', onDepartEnd);
          if (!current()) { cancel(); return; }
          if (!hold) veil.classList.remove('vault-leave--depart', 'vault-leave--logo');
          next(true);
        }
        function onDepartEnd(e) { if (e.animationName === (hold ? 'logoHoldIn' : 'logoDepart')) go(); }
        veilLogo.addEventListener('animationend', onDepartEnd);
        window.setTimeout(function () { veilLogo.removeEventListener('animationend', onDepartEnd); }, (hold ? 720 : DEPART_MS) + 450);
        window.setTimeout(go, (hold ? 720 : DEPART_MS) + 400);
      }

      /* Fade, then go. Used for taps and for page changes started by code
         (menu slide, product cards, search, cart...). */
      function leaveTo(url, replace) {
        try {
          var returnState = Object.assign({}, history.state), returnPath = location.pathname.replace(/\/+$/, '');
          if (!logos[returnPath] && logoFor(url)) returnState.vaultReturnLogo = url.pathname.replace(/\/+$/, '');
          else delete returnState.vaultReturnLogo;
          history.replaceState(returnState, '', location.href);
        } catch (_) {}
        if (leaveTo.departed && leaveTo.pending && !leaveTo.pending.done) {
          leaveTo.pending.done = true; leaveTo.departed = false; leaveCycle += 1;
        }
        if (!leaveTo.departed) {
          if (shownSoft) saveSoftSource();
          leaveTo.departed = true;
          var request = leaveTo.pending = { entry: window.vaultEntryKey(), url: url, replace: replace, done: false };
          veil.classList.remove('vault-leave--quiet');
          /* Brand/idol -> brand/idol: the next page's entry wins, no exit. */
          var skip = !!logoFor(url);
          if (!skip && softEligible(url)) fetchPage(url.href); /* download while the logo leaves */
          departThen(function (played) {
            if (request.done || leaveTo.pending !== request || request.entry !== window.vaultEntryKey()) return;
            request.done = true;
            if (played) veil.classList.add('vault-leave--quiet');
            leaveTo(url, replace);
            leaveTo.departed = false;
          }, skip, null, softEligible(url), function () {
            if (request.done || leaveTo.pending !== request) return;
            request.done = true; leaveTo.departed = false;
            /* A cancelled logo must not consume a tap still owned by this entry. */
            if (request.entry !== window.vaultEntryKey() || request.departed) return;
            if (replace) location.replace(url.href); else location.href = url.href;
          });
          return;
        }
        if (softEligible(url)) {
          softLeave(url, false, replace);
          return;
        }
        /* Normal page change: plain white only (no words from an earlier swap). */
        veil.classList.remove('vault-leave--soft', 'vault-leave--exit', 'vault-leave--return');
        if (logoFor(url)) veil.classList.remove('vault-leave--quiet');
        var went = false, sourceEntry = window.vaultEntryKey();
        navPhase = 'leaving';
        function go(why) {
          if (went || cycle !== leaveCycle || navPhase !== 'leaving' || sourceEntry !== window.vaultEntryKey()) return;
          navPhase = 'departing';
          went = true;
          window.clearTimeout(leaveTimer);
          root.classList.add('vault-cover');
          dbg('go ' + why + ' ' + url.pathname + url.search);
          try {
            sessionStorage.setItem('vault_handoff', JSON.stringify({
              path: url.pathname.replace(/\/+$/, ''), t: Date.now(),
              logo: veil.classList.contains('vault-leave--logo-ready'),
              quiet: veil.classList.contains('vault-leave--quiet')
            }));
          } catch (err) {}
          if (replace) location.replace(url.href);
          else location.href = url.href;
        }
        /* Go once the fade has fully finished and the page is hidden. */
        showVeil(url, false, function () { go('after fade'); });
        /* Safety net if a busy phone delays the fade. */
        var cycle = leaveCycle;
        window.clearTimeout(leaveTimer);
        leaveTimer = window.setTimeout(function () {
          if (leaving && cycle === leaveCycle) go('safety');
        }, LEAVE_MS + 400);
        /* If the next page never arrives (offline, cancelled), show this one again. */
        window.clearTimeout(stuckTimer);
        stuckTimer = window.setTimeout(function () {
          if (leaving && cycle === leaveCycle) {
            dbg('next page never arrived — uncovering');
            restore(false);
          }
        }, 15000);
      }

      /* ---------- Seamless page change (never leave the page) ----------
         On iPhone, a real page switch briefly shows the old page shifted ~100pt
         (iOS bug), so the words/logo would jump. Instead the next page is
         downloaded in the background and its content swapped in under the white
         screen. Product pages, cart, checkout and account always load normally
         (keeps Shopify/Meta/Google "product viewed" tracking intact).
         Off-switch for testing: open any page with ?vaultsoft=0 (?vaultsoft=1 = on). */
      var SOFT = false;
      try {
        if (/[?&]vaultsoft=0/.test(location.search)) localStorage.setItem('vaultsoft', '0');
        if (/[?&]vaultsoft=1/.test(location.search)) localStorage.removeItem('vaultsoft');
        SOFT = localStorage.getItem('vaultsoft') !== '0' && !!window.DOMParser &&
          !!(window.history && history.pushState) && !!window.fetch && !!window.Promise;
      } catch (err) {}
      var shownPath = location.pathname + location.search;
      var shownSoft = !!(history.state || {}).vaultSoft;
      var navPhase = 'idle', softScrollY = window.scrollY, softScrolls = {};
      function entryScroll() {
        var entry = window.vaultEntryKey();
        return softScrolls[entry] != null ? softScrolls[entry] : ((history.state || {}).vaultSoftScroll || 0);
      }
      function saveSoftSource() {
        shownSoft = true;
        var state = Object.assign({}, history.state, { vaultSoft: 1, vaultSoftScroll: softScrollY, vaultSoftPath: shownPath });
        history.replaceState(state, '', location.href);
      }
      /* once per frame, not per scroll event: reading scrollY forces a layout while the page is changing (low-end
         Android spent 0.56 s in it during one style switch, R34) */
      var softScrollQueued = false;
      window.addEventListener('scroll', function () {
        if (softScrollQueued) return;
        softScrollQueued = true;
        requestAnimationFrame(function () {
          softScrollQueued = false;
          if (navPhase === 'idle' && location.pathname + location.search === shownPath) {
            softScrollY = window.scrollY;
            softScrolls[window.vaultEntryKey()] = softScrollY;
          }
        });
      }, { passive: true });

      function softEligible(url) {
        if (!SOFT || url.origin !== location.origin) return false;
        if (/^\/collections(\/|$)/.test(url.pathname) || /^\/collections(\/|$)/.test(shownPath.split('?')[0])) return false;
        if (/^\/(cart|checkout|checkouts|account|challenge|password|apps|tools|admin|policies|services|products|search)(\/|$)/.test(url.pathname)) return false;
        if (/\/products\//.test(url.pathname)) return false; /* /collections/x/products/y */
        if (!document.getElementById('MainContent')) return false;
        return true;
      }

      /* Run the new content's scripts like a normal page load would. */
      function runScripts(container) {
        var scriptEntry = window.vaultEntryKey(), scriptCycle = leaveCycle;
        function currentScripts() { return scriptEntry === window.vaultEntryKey() && scriptCycle === leaveCycle; }
        var list = Array.prototype.slice.call(container.querySelectorAll('script'));
        var origDocAdd = document.addEventListener;
        var origWinAdd = window.addEventListener;
        document.addEventListener = function (type, fn, opts) {
          if (type === 'DOMContentLoaded') {
            window.setTimeout(function () { if (!currentScripts()) return; try { fn.call(document, new Event('DOMContentLoaded')); } catch (e) {} }, 0);
            return;
          }
          return origDocAdd.call(document, type, fn, opts);
        };
        window.addEventListener = function (type, fn, opts) {
          if (type === 'load') {
            window.setTimeout(function () { if (!currentScripts()) return; try { fn.call(window, new Event('load')); } catch (e) {} }, 0);
            return;
          }
          return origWinAdd.call(window, type, fn, opts);
        };
        /* Components a section registers again are already registered. */
        var origDefine = window.customElements && customElements.define;
        if (origDefine) {
          customElements.define = function (name) {
            if (customElements.get(name)) return;
            return origDefine.apply(customElements, arguments);
          };
        }
        function unpatch() {
          document.addEventListener = origDocAdd;
          window.addEventListener = origWinAdd;
          if (origDefine) customElements.define = origDefine;
        }
        return list.reduce(function (chain, old) {
          return chain.then(function () {
            if (!currentScripts()) return;
            return new Promise(function (resolve) {
              var type = (old.getAttribute('type') || '').toLowerCase();
              if (type && ['text/javascript', 'application/javascript', 'module'].indexOf(type) === -1) {
                resolve(); /* JSON data blocks etc. stay as they are */
                return;
              }
              dbg('soft: script ' + (old.src ? old.src.split('/').pop().slice(0, 40) : 'inline'));
              var s = document.createElement('script');
              for (var i = 0; i < old.attributes.length; i++) s.setAttribute(old.attributes[i].name, old.attributes[i].value);
              if (old.src) {
                s.async = false;
                s.onload = function () { resolve(); };
                s.onerror = function () { var name = old.getAttribute('data-vault-asset'); if (name) window.vaultInit.fail(name); resolve(); };
                window.setTimeout(resolve, 3000); /* never wait on one script for long */
              } else {
                s.textContent = old.textContent;
              }
              old.parentNode.replaceChild(s, old);
              if (!old.src) resolve();
            });
          });
        }, Promise.resolve()).then(function () {
          window.setTimeout(unpatch, 0);
        }, function () {
          unpatch();
        });
      }

      function softSwap(url, html, isPop, replace) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('MainContent');
        var current = document.getElementById('MainContent');
        if (!fresh || !current) throw new Error('no main content');
        document.title = doc.title;
        /* Stylesheets the new page needs that are not loaded yet. */
        var have = {};
        document.querySelectorAll('link[rel="stylesheet"]').forEach(function (l) { have[l.href] = 1; });
        doc.querySelectorAll('head link[rel="stylesheet"]').forEach(function (l) {
          var href = new URL(l.getAttribute('href'), url.href).href;
          if (have[href]) return;
          var n = document.createElement('link');
          n.rel = 'stylesheet';
          n.href = href;
          document.head.appendChild(n);
        });
        document.dispatchEvent(new CustomEvent('vault:before-swap'));
        document.body.className = doc.body.className;
        /* Popups the old page's sections moved out to <body> (Dawn modals, e.g. the product photo zoom) would stay
           behind without their section's styles: the 1100px photo row then made the page wider than the screen and
           phones zoomed out (page shown at a third of its width). Header/footer popups stay. */
        var oldSections = {}, oldIds = [];
        current.querySelectorAll('.shopify-section').forEach(function (s) {
          var id = s.id.replace('shopify-section-', '');
          if (id) { oldSections[id] = 1; oldIds.push(id); }
        });
        /* Moved by Dawn's modals (data-section), or copied out by a section's own script (its class names carry
           the section id, e.g. the size guide's popup). */
        Array.prototype.slice.call(document.body.children).forEach(function (el) {
          var cls = typeof el.className === 'string' ? el.className : '';
          if ((el.dataset && el.dataset.section && oldSections[el.dataset.section]) ||
              oldIds.some(function (id) { return cls.indexOf(id) !== -1; })) el.remove();
        });
        window.vaultInit.swap(current);
        var node = document.importNode(fresh, true);
        current.parentNode.replaceChild(node, current);
        if (!isPop) {
          /* searchParams: Dawn's filters (facets.js) never reload the grid for our own history steps */
          var destState = Object.assign({}, history.state, { vaultSoft: 1, vaultSoftPath: url.pathname + url.search, vaultSoftScroll: 0,
            vaultEntry: String(Date.now()) + Math.random().toString(36).slice(2), searchParams: url.search.slice(1) });
          destState = window.vaultNewGridState(destState);
          if (replace) history.replaceState(destState, '', url.href);
          else history.pushState(destState, '', url.href);
        }
        shownPath = url.pathname + url.search; shownSoft = true;
        softScrollY = isPop ? entryScroll() : 0;
        window.scrollTo(0, softScrollY);
        /* Back/Forward: the new page's scripts can show it as it was (e.g. the shuffled grid's order) */
        window.vaultSoftPop = !!isPop;
        var entry = window.vaultEntryKey(), scrollCycle = leaveCycle;
        return runScripts(node).then(function () {
          if (entry !== window.vaultEntryKey() || scrollCycle !== leaveCycle) return;
          requestAnimationFrame(function () {
            if (entry !== window.vaultEntryKey() || scrollCycle !== leaveCycle) return;
            window.scrollTo(0, isPop ? entryScroll() : 0);
            softScrollY = window.scrollY;
          });
          if (typeof window.initializeScrollAnimationTrigger === 'function') {
            try { window.initializeScrollAnimationTrigger(); } catch (e) {}
          }
          document.dispatchEvent(new CustomEvent('vault:soft-load', { detail: { url: url.href } }));
        });
      }

      /* Like a normal load: let the top of the new page settle, then play the
         preloader's own ending (words blur away / logo zooms) and show it. */
      function softReveal(url, cycle) {
        return new Promise(function (resolve) {
          /* Same photos as a full load waits for (first screen + a product grid's first row). */
          var imgs = window.vaultFirstSeenImages ? window.vaultFirstSeenImages(true)
            : Array.prototype.slice.call(document.querySelectorAll('#MainContent img')).filter(function (im) {
              var r = im.getBoundingClientRect();
              return r.width > 40 && r.top < window.innerHeight && r.bottom > 0 && im.loading !== 'lazy' && !im.hasAttribute('data-src');
            }).slice(0, 6);
          var ready = Promise.all(imgs.map(function (im) {
            if (im.complete) return 0;
            return new Promise(function (ok) {
              im.addEventListener('load', ok, { once: true });
              im.addEventListener('error', ok, { once: true });
            });
          }));
          Promise.all([Promise.race([ready, new Promise(function (ok) { window.setTimeout(ok, 1200); })]), prepareDefaultReturn()])
            .then(function () { return new Promise(function (ok) { window.setTimeout(ok, 300); }); })
            .then(function () {
              if (cycle !== leaveCycle) { resolve(); return; }
              var info = logos[url.pathname.replace(/\/+$/, '')];
              if (info) veilLogo.style.setProperty('--logo-zoom', info[1]);
              var mover = veil.classList.contains('vault-leave--logo') ? veilLogo : veil.querySelector('.vault-leave__text');
              var held = veil.classList.contains('vault-leave--hold');
              if (held) {
                /* the leaving page's logo, held in the middle while this page loaded: now it blurs away */
                veil.classList.add('vault-leave--holdout');
                mover = veilLogo;
              } else if (veil.classList.contains('vault-leave--return')) {
                /* Back to a brand/idol page: logo leaves (big -> small -> gone). */
                veil.classList.remove('vault-leave--return');
                veil.classList.add('vault-leave--depart');
              } else {
                veil.classList.add('vault-leave--exit');
              }
              dbg('soft: ending animation');
              var done = false;
              function finish() {
                if (done) return;
                done = true;
                if (mover) mover.removeEventListener('animationend', finish);
                if (cycle !== leaveCycle) { resolve(); return; }
                root.classList.remove('has-preloader');
                restore(false);
                var cleanupCycle = leaveCycle;
                window.setTimeout(function () {
                  if (leaving || cleanupCycle !== leaveCycle) return;
                  veil.classList.remove('vault-leave--soft', 'vault-leave--exit', 'vault-leave--depart', 'vault-leave--return', 'vault-leave--quiet', 'vault-leave--hold', 'vault-leave--holdout');
                  if (held) veil.classList.remove('vault-leave--logo');
                }, 450);
                resolve();
              }
              if (mover) mover.addEventListener('animationend', finish, { once: true });
              /* a held logo blurs away while the page already fades in (no empty white after it) */
              if (held) window.setTimeout(finish, 300);
              window.setTimeout(finish, 1900);
            });
        });
      }

      /* Start downloading as soon as a finger touches a link. */
      var prefetched = {};
      function fetchPage(href) {
        var hit = prefetched[href];
        if (hit && Date.now() - hit.at < 10000) return hit.p;
        var p = fetch(href, { credentials: 'same-origin', headers: { Accept: 'text/html' } });
        prefetched[href] = { at: Date.now(), p: p };
        p.catch(function () { delete prefetched[href]; });
        return p;
      }
      document.addEventListener('pointerdown', function (e) {
        if (!SOFT || leaving) return;
        var url = linkFrom(e);
        if (url && softEligible(url)) fetchPage(url.href);
      }, { passive: true });

      function softLeave(url, isPop, replace) {
        if (!isPop) saveSoftSource();
        navPhase = 'soft';
        try { history.scrollRestoration = 'manual'; } catch (_) {}
        dbg('soft ' + url.pathname);
        var htmlP = fetchPage(url.href)
          .then(function (r) {
            delete prefetched[url.href];
            if (!r.ok || !/text\/html/.test(r.headers.get('content-type') || '')) throw new Error('not html');
            if (r.redirected) url = new URL(r.url);
            dbg('soft: response ' + r.status);
            return r.clone().text();
          }).then(function (t) { dbg('soft: html ' + t.length); return t; });
        veil.classList.remove('vault-leave--exit');
        veil.classList.add('vault-leave--soft');
          veil.classList.remove('vault-leave--return'); /* Back/Forward onto a brand/idol page plays its entry */
        root.classList.add('has-preloader');
        var covered = new Promise(function (resolve) { showVeil(url, false, resolve); }).then(function () { dbg('soft: covered'); });
        var cycle = leaveCycle, sourceEntry = window.vaultEntryKey();
        var swapped = false;
        /* Very slow download: fall back to a normal page load, which can
           start showing the page before it has fully arrived. */
        window.setTimeout(function () {
          if (cycle !== leaveCycle || sourceEntry !== window.vaultEntryKey() || navPhase !== 'soft' || !leaving || swapped) return;
          dbg('soft watchdog: download too slow');
          location.href = url.href;
        }, 30000);
        /* Once swapped, never keep the white up more than 5s for scripts. */
        function afterSwapWatchdog() {
          window.setTimeout(function () {
            if (cycle !== leaveCycle || !leaving) return;
            prepareDefaultReturn().then(function () {
              if (cycle !== leaveCycle || !leaving) return;
              dbg('soft watchdog: revealing');
              root.classList.remove('has-preloader');
              restore(false);
            });
          }, 3000);
        }
        Promise.all([htmlP, covered]).then(function (res) {
          if (cycle !== leaveCycle) return;
          if (sourceEntry !== window.vaultEntryKey() || navPhase !== 'soft') return;
          dbg('soft: swapping');
          var swap = softSwap(url, res[0], isPop, replace);
          swapped = true;
          afterSwapWatchdog();
          dbg('soft: swapped, running scripts');
          return swap;
        }).then(function () {
          dbg('soft: scripts done');
          if (cycle !== leaveCycle) return;
          return softReveal(url, cycle);
        }).catch(function (err) {
          dbg('soft failed: ' + err);
          if (cycle !== leaveCycle) return;
          if (swapped) {
            root.classList.remove('has-preloader');
            restore(false);
          } else {
            if (sourceEntry !== window.vaultEntryKey() || navPhase !== 'soft') return;
            location.href = url.href; /* fall back to a normal page change */
          }
        });
      }

      window.addEventListener('popstate', function (event) {
        if (window.__vaultHistoryHop) return;
        var url = new URL(location.href);
        var softPop = SOFT && shownSoft && event.state && event.state.vaultSoft && (history.state || {}).vaultSoft && !/^\/collections(\/|$)/.test(shownPath.split('?')[0]);
        /* Keep manual restoration through restore() and the departing logo, before softLeave starts. */
        restore(true, softPop && url.pathname !== shownPath.split('?')[0] && softEligible(url));
        if (!softPop) return;
        /* Same page, only the address details changed (variant, filters,
           #section, a page's own Back guard) — that page handles it. */
        if (url.pathname === shownPath.split('?')[0]) return;
        if (!softEligible(url)) {
          location.reload(); /* e.g. Back to a product page: load it normally */
          return;
        }
        var from = shownPath.split('?')[0].replace(/\/+$/, '');
        veil.classList.remove('vault-leave--quiet');
        if (logos[from] && !logoFor(url)) {
          fetchPage(url.href);
          leaving = true;
          departFrom(from, function () {
            veil.classList.add('vault-leave--quiet');
            softLeave(url, true, false);
          });
          return;
        }
        softLeave(url, true, false);
      });

      /* Last safety net: nothing is covering any more (preloader gone, no page change running, no white veil)
         but the page is still hidden – a page change that never finished left it white ("stuck after loading,
         had to refresh"). After 3s like that, show the page. */
      var staleCover = 0, staleVeil = 0;
      window.setInterval(function () {
        /* the white veil itself up for 20s on a visible page (a page change that lost track of itself) */
        if (leaving && !document.hidden && veil.classList.contains('vault-leave--on')) {
          if (++staleVeil >= 20) { staleVeil = 0; dbg('stale veil removed'); root.classList.remove('has-preloader'); restore(false); }
        } else staleVeil = 0;
        var mainPre = document.getElementById('preloader');
        var mainUp = mainPre && !mainPre.classList.contains('preloader--hide') && mainPre.style.display !== 'none';
        var hiddenPage = root.classList.contains('vault-cover') || root.classList.contains('has-preloader');
        if (leaving || document.hidden || mainUp || !hiddenPage || veil.classList.contains('vault-leave--on')) { staleCover = 0; return; }
        if (++staleCover < 3) return;
        staleCover = 0;
        dbg('stale cover removed');
        root.classList.remove('vault-cover', 'has-preloader');
      }, 1000);

      window.vaultLeave = function (href) {
        var url = new URL(href, location.href);
        if (leaving) { if (leaveTo.pending) leaveTo.pending.done = true; restore(true); }
        if (window.vaultSkipLeave || !isLeave(url)) {
          location.href = url.href;
          return;
        }
        leaveTo(url, false);
      };

      /* Start loading the logo as soon as a finger / mouse goes down. */
      document.addEventListener('pointerdown', function (e) {
        var url = linkFrom(e);
        var src = url && logoFor(url);
        if (src && veilLogo.getAttribute('src') !== src) {
          veil.classList.remove('vault-leave--logo-ready');
          veilLogo.src = src;
        }
      }, { passive: true });

      document.addEventListener('click', function (e) {
        /* vaultCardTap: a product card in a row – the header flies its photo instead (ss-header-9). */
        if (e.defaultPrevented || e.vaultCardTap) return;
        var url = linkFrom(e);
        if (!url) return;
        if (leaving) { if (leaveTo.pending) leaveTo.pending.done = true; restore(true); }
        e.preventDefault();
        dbg('tap ' + url.pathname);
        leaveTo(url, false);
      });

      /* Page changes started by code: hold them, fade, then go. */
      if (window.navigation && typeof window.navigation.addEventListener === 'function') {
        window.navigation.addEventListener('navigate', function (e) {
          var url = e.destination && new URL(e.destination.url);
          if (!url) return;
          dbg('navigation destination ' + url.href);
          /* Back/Forward between soft-swapped pages: the browser would restore the destination's scroll on the
             page still showing (one visible frame of the old page scrolled). The swap restores it instead. */
          if ((typeof SOFT === 'undefined' || SOFT) && e.navigationType === 'traverse' && e.destination.sameDocument && url.pathname !== location.pathname) {
            try { history.scrollRestoration = 'manual'; } catch (_) {}
          }
          if (e.destination.sameDocument !== false) return;
          if (window.vaultSourceKey(url.href) === window.vaultSourceKey(location.href)) {
            /* Preview-bar reloads (pb=0) share our page key: skip animation, let the browser navigate. */
            return;
          }
          if (leaving || window.vaultSkipLeave || e.hashChange || e.downloadRequest || e.formData) return; /* vaultSkipLeave: Add to Cart black transition */
          if (['push', 'replace', 'reload'].indexOf(e.navigationType) === -1) return;
          if (!isLeave(url)) return;
          if (e.cancelable && !e.userInitiated) {
            e.preventDefault();
            dbg('held code navigation (' + e.navigationType + ') ' + url.href);
            leaveTo(url, e.navigationType === 'replace');
            return;
          }
          dbg('navigation ' + e.navigationType + ' ' + url.href + ' (cannot hold)');
          showVeil(url, true);
        });
      }

      /* Pull-to-refresh (Chrome/Safari on phones). The finger distance does
         not tell whether Chrome will reload, so: the page blurs into white
         while you pull (already covered before Chrome reloads), then
         Chrome's screen size tells us — it snaps straight back to full height
         on a reload, and animates back when there is no reload. */
      var pull = null;
      var baseIH = window.innerHeight;
      var watchPull = null;

      function overscroll() {
        var v = window.visualViewport;
        return Math.max(-window.scrollY, v ? -v.offsetTop : 0, 0);
      }

      function dragVeil(o) {
        if (!veil.matches(':popover-open')) {
          veil.classList.remove('vault-leave--logo', 'vault-leave--on');
          document.body.appendChild(veil);
          try { veil.popover = 'manual'; veil.showPopover(); } catch (err) {}
        }
        veil.classList.add('vault-leave--drag');
        veil.style.opacity = String(o);
      }

      function endDrag() {
        veil.classList.remove('vault-leave--drag');
        veil.style.opacity = '';
      }

      window.addEventListener('touchstart', function (e) {
        pull = null;
        if (leaving || e.touches.length !== 1 || window.scrollY > 2) return;
        baseIH = window.innerHeight; /* full height before Chrome's pull bar appears */
        pull = { dragging: false };
      }, { passive: true });

      window.addEventListener('touchmove', function (e) {
        if (!pull || e.touches.length !== 1) return;
        var o = Math.max(0, Math.min(1, (overscroll() - 15) / 70));
        if (o > 0 || pull.dragging) {
          pull.dragging = true;
          dragVeil(o);
        }
      }, { passive: true });

      function endPull(e) {
        var p = pull;
        pull = null;
        if (!p || leaving) return;
        var pullBar = window.innerHeight < baseIH - 20;
        var over = overscroll();
        if (!p.dragging && !pullBar && over < 5) return;
        if (!pullBar && over < 5) {
          /* Pulled a little, then back up — no refresh. */
          endDrag();
          try { if (veil.matches(':popover-open')) veil.hidePopover(); } catch (err) {}
          return;
        }

        dbg('pull ' + e.type + ' over' + Math.round(over) + ' bar=' + pullBar);
        /* Go to solid white from wherever the drag left it, and hide the page
           and words at once — Chrome freezes its picture right after release. */
        root.classList.add('vault-cover');
        showVeil(null, true);
        endDrag();

        var cycle = leaveCycle;
        function noReload(why) {
          if (!leaving || cycle !== leaveCycle) return;
          dbg('no reload after pull (' + why + ') — uncovering');
          restore(false);
        }
        /* First screen-size change after letting go decides it. */
        watchPull = function () {
          if (!leaving || cycle !== leaveCycle) return;
          var ih = window.innerHeight;
          if (ih >= baseIH - 2) {
            dbg('reload confirmed (screen snapped back)');
            watchPull = null;
            /* Keep the white up for the reload; only a long-stuck reload uncovers. */
            window.clearTimeout(undoTimer);
            undoTimer = window.setTimeout(function () { noReload('reload never arrived'); }, 15000);
          } else if (ih < baseIH - 2) {
            watchPull = null;
            noReload('screen animating back');
          }
        };
        undoTimer = window.setTimeout(function () { noReload('timeout'); }, 1500);
      }

      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', function () {
          if (watchPull) watchPull();
        });
      }

      window.addEventListener('touchend', endPull, { passive: true });
      window.addEventListener('touchcancel', endPull, { passive: true });

      /* Bring the page back: instantly (Back/Forward) or with a fade. */
      function restore(instant, softOwned) {
        var photoOwned = photoTransitionActive();
        historyArrival = null;
        navPhase = 'idle'; leaveTo.departed = false; departThen.waited = false;
        try { if (!photoOwned && !window.__vaultHoldScroll) history.scrollRestoration = softOwned ? 'manual' : 'auto'; } catch (_) {} /* __vaultHoldScroll: assets/vault-fly.js card return */
        leaving = false;
        leaveCycle += 1;
        var mainPre = document.getElementById('preloader');
        if (!photoOwned && (!mainPre || mainPre.classList.contains('preloader--hide') || mainPre.style.display === 'none')) root.classList.remove('has-preloader');
        [leaveTimer, showTimer, coverTimer, undoTimer, stuckTimer, slowTimer].forEach(function (t) { window.clearTimeout(t); });
        root.classList.remove('vault-leaving');
        if (!photoOwned && !root.classList.contains('has-preloader')) root.classList.remove('vault-cover');
        veilLogo.style.animation = ''; veilLogo.style.transition = ''; veilLogo.style.opacity = ''; veilLogo.style.filter = '';
        var transition = veil.style.transition;
        if (instant) veil.style.transition = 'none';
        veil.classList.remove('vault-leave--on', 'vault-leave--fast', 'vault-leave--slow', 'vault-leave--depart', 'vault-leave--return', 'vault-leave--hold', 'vault-leave--holdout', 'vault-leave--logo-ready');
        if (instant) {
          try { if (veil.matches(':popover-open')) veil.hidePopover(); } catch (err) {}
          void veil.offsetWidth;
          veil.style.transition = transition;
        } else {
          window.setTimeout(function () {
            if (leaving) return;
            try { if (veil.matches(':popover-open')) veil.hidePopover(); } catch (err) {}
          }, 400);
        }
      }

      function historyEntryWanted() {
        if (window.vaultFlyBackHere() || photoTransitionActive() || document.hidden) return false;
        /* 0.7.2 tap blur fades out by itself on Back (its veil is still there before its own pageshow runs) */
        return !document.querySelector('.vault-focus-veil') && !(window.__vaultFocusReturn && Date.now() - window.__vaultFocusReturn < 2000);
      }
      /* Back/Forward: the white is up in the very frame the page comes back, then the entry plays and shows it. It
         used to fade in over the page already showing (Mark 2026-10-20, video 1: "I can see the page before it appears"). */
      function coverAtOnce() {
        if (!veil.matches(':popover-open')) document.body.appendChild(veil);
        try { veil.popover = 'manual'; if (!veil.matches(':popover-open')) veil.showPopover(); } catch (err) {}
        var transition = veil.style.transition;
        veil.style.transition = 'none';
        veil.classList.add('vault-leave--on');
        void veil.offsetWidth;
        veil.style.transition = transition;
      }
      var historyShown = null; /* this visit's entry already played (a reloaded Back plays it before its late pageshow) */
      function playHistoryEntry(instant) {
        var path = location.pathname.replace(/\/+$/, ''), info = logos[path], entry = window.vaultEntryKey();
        if (!historyEntryWanted()) return;
        if (historyArrival && historyArrival.entry === entry && historyArrival.path === path) return;
        if (historyShown === entry + '|' + path) return;
        historyShown = entry + '|' + path;
        var returnLogo = !info && ((window.history && window.history.state) || {}).vaultReturnLogo;
        if (returnLogo && logos[returnLogo]) {
          historyArrival = { entry: entry, path: path };
          navPhase = 'arrival'; leaving = true;
          if (instant) coverAtOnce();
          departThen(function () { restore(false); }, false, returnLogo, false);
          return;
        }
        if (!info) {
          historyArrival = { entry: entry, path: path };
          veil.classList.remove('vault-leave--exit', 'vault-leave--quiet', 'vault-leave--return');
          veil.classList.add('vault-leave--soft');
          showVeil(new URL(location.href), false, function () { softReveal(new URL(location.href), leaveCycle); });
          if (instant) coverAtOnce();
          return;
        }
        var cycle = ++leaveCycle, finished = false, exiting = false;
        historyArrival = { entry: entry, path: path };
        navPhase = 'arrival'; leaving = true;
        function current() {
          return cycle === leaveCycle && entry === window.vaultEntryKey() && path === location.pathname.replace(/\/+$/, '') &&
            !document.hidden && !photoTransitionActive();
        }
        function later(fn, ms) { window.setTimeout(function () { if (current()) fn(); }, ms); }
        veilLogo.src = info[0]; veilLogo.style.setProperty('--logo-zoom', info[1]);
        if (!veil.matches(':popover-open')) document.body.appendChild(veil);
        try { veil.popover = 'manual'; if (!veil.matches(':popover-open')) veil.showPopover(); } catch (err) {}
        veil.classList.remove('vault-leave--depart', 'vault-leave--return', 'vault-leave--exit', 'vault-leave--quiet', 'vault-leave--hold', 'vault-leave--holdout', 'vault-leave--logo-ready');
        if (instant) coverAtOnce();
        veil.classList.add('vault-leave--on', 'vault-leave--logo', 'vault-leave--soft');
        function enterDone() {
          if (finished || !current()) return;
          finished = true;
          veilLogo.removeEventListener('animationend', onEnd);
          /* The failsafe also blurs out; it must never cut off a still-visible logo. */
          veilLogo.style.animation = 'none';
          veilLogo.style.transition = 'opacity .3s ease-out, filter .3s ease-out';
          veilLogo.style.opacity = '0'; veilLogo.style.filter = 'blur(12px)';
          later(function () {
            restore(false);
            var cleanupCycle = leaveCycle;
            window.setTimeout(function () {
              if (cleanupCycle !== leaveCycle || leaving) return;
              veil.classList.remove('vault-leave--soft', 'vault-leave--exit', 'vault-leave--logo', 'vault-leave--logo-ready');
            }, 450);
          }, 300);
        }
        function onEnd(event) { if (event.animationName === 'preloaderLogo') enterDone(); }
        function beginExit() {
          if (exiting) return;
          exiting = true;
          veil.classList.add('vault-leave--exit');
          veilLogo.addEventListener('animationend', onEnd);
        }
        var ready = veilLogo.decode ? veilLogo.decode().catch(function () {}) : Promise.resolve();
        Promise.race([ready, new Promise(function (ok) { window.setTimeout(ok, 600); })]).then(function () {
          if (!current()) return;
          veil.classList.add('vault-leave--logo-ready');
          later(beginExit, 650);
        });
        later(enterDone, 3200);
        window.setTimeout(function () { veilLogo.removeEventListener('animationend', onEnd); }, 3550);
      }

      /* Keep the white up while the browser leaves (removing it then showed
         the old page jumping). Clear it only when Back/Forward brings this
         page back from memory. */
      window.addEventListener('pageshow', function (e) {
        if (!e.persisted) {
          var nav = window.performance && window.performance.getEntriesByType && window.performance.getEntriesByType('navigation')[0];
          if (!nav || nav.type !== 'back_forward' || logos[location.pathname.replace(/\/+$/, '')]) return;
        } else {
          dbg('restored from Back/Forward');
          restore(true);
          shownPath = location.pathname + location.search;
          softScrollY = window.scrollY; shownSoft = !!(history.state || {}).vaultSoft;
        }
        var entry = window.vaultEntryKey(), path = location.pathname;
        var early = e.persisted && historyEntryWanted();
        if (early) coverAtOnce();
        /* Native popstate follows pageshow; start once that traversal has settled. */
        window.setTimeout(function () {
          if (entry === window.vaultEntryKey() && path === location.pathname && navPhase === 'idle') playHistoryEntry(true);
          if (early && !leaving) restore(true); /* no entry after all: the early white goes again */
        }, 0);
      });
      /* A Back that reloads the page: its pageshow waits for every app script (seconds), so the entry starts as
         soon as the page is ready under the loader (assets/vault-preloader.js arrival, clearPreloaderForHistory). */
      window.vaultHistoryEntryNow = function () { if (navPhase === 'idle') playHistoryEntry(true); };
      window.addEventListener('pagehide', function () {
        historyShown = null;
        if (leaveTo.pending) leaveTo.pending.departed = true;
        if (shownSoft && location.pathname + location.search === shownPath) saveSoftSource();
        navPhase = 'departed'; leaveCycle += 1;
      });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden && navPhase === 'arrival') restore(true); /* app switch mid-entry: never leave the white cover stuck on return */
      });
    })();
  
    }
  };
  window.VaultPreloader = window.VaultPreloader || {
    phases: phases,
    init: function (phase, root, config) { phases[phase](root, config); }
  };
  window.vaultInit.drain('Preloader');
})();
